module.exports = __webpack_public_path__ + "532aaef1988c0cb07d3cb2ff93a47127.ttf";